import { render, staticRenderFns } from "./tCustomerSearch.vue?vue&type=template&id=2fba3488&scoped=true"
import script from "./tCustomerSearch.vue?vue&type=script&lang=js"
export * from "./tCustomerSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fba3488",
  null
  
)

export default component.exports